import { Plugin } from '@tiptap/pm/state';
import { MAX_FILE_SIZE_BYTES, MAX_FILES_PER_MESSAGE, MAX_TOTAL_EMAIL_MESSAGE_SIZE_BYTES, } from '../../file-upload/constants';
import { validateFiles } from '../../file-upload/validations';
const createImageNode = ({ view, coordinates, url, onError, }) => {
    if (!url) {
        onError?.('Something went wrong creating the image. Empty image URL');
        return;
    }
    const { schema } = view.state;
    const imageNode = schema.nodes.image ?? schema.nodes.imageResize;
    if (!imageNode) {
        onError?.('Something went wrong creating the image. Image extension missing');
        return;
    }
    const node = imageNode.create({
        src: url,
        loading: 'lazy',
    });
    const transaction = coordinates
        ? view.state.tr.insert(coordinates.pos, node)
        : view.state.tr.replaceSelectionWith(node);
    view.dispatch(transaction);
};
const addImages = ({ event, view, coordinates, onError, uploadFile, }) => {
    const files = event instanceof ClipboardEvent
        ? [...(event.clipboardData?.files ?? [])]
        : [...(event.dataTransfer?.files ?? [])];
    const hasFiles = files?.length;
    if (!hasFiles) {
        return;
    }
    const images = Array.from(files).filter((file) => file.type.includes('image'));
    if (images.length === 0) {
        return;
    }
    event.preventDefault();
    const validationResult = validateFiles(files, {
        maxFiles: MAX_FILES_PER_MESSAGE,
        maxFileSize: MAX_FILE_SIZE_BYTES,
        maxTotalFilesSizeBytes: MAX_TOTAL_EMAIL_MESSAGE_SIZE_BYTES,
    });
    if (!validationResult.valid) {
        onError?.(validationResult.message);
        return;
    }
    for (const image of images) {
        uploadFile?.({ file: image })
            .then((url) => {
            createImageNode({
                url,
                view,
                coordinates,
                onError,
            });
        })
            .catch((e) => {
            console.error(e);
        });
    }
};
export const imageExtend = ({ onError, uploadFile, enableInteractions = true, }) => ({
    addAttributes() {
        return {
            ...this.parent?.(),
            width: {
                default: null,
            },
            height: {
                default: null,
            },
            loading: {
                default: null,
            },
        };
    },
    addProseMirrorPlugins() {
        if (!enableInteractions) {
            // Static previews still need the node, but must skip editor-only event handlers.
            return this.parent?.() || [];
        }
        return [
            ...(this.parent?.() || []),
            new Plugin({
                props: {
                    handleDOMEvents: {
                        drop(view, event) {
                            const coordinates = view.posAtCoords({
                                left: event.clientX,
                                top: event.clientY,
                            });
                            if (!coordinates) {
                                onError?.('Position is outside the editor');
                                return;
                            }
                            addImages({
                                event,
                                view,
                                coordinates,
                                onError,
                                uploadFile,
                            });
                        },
                        paste(view, event) {
                            addImages({ event, view, onError, uploadFile });
                        },
                    },
                },
            }),
        ];
    },
});
